export const isInternetExplorer = /MSIE|Trident/.test(
  window.navigator.userAgent
);

export const isEdge = /Edge/.test(window.navigator.userAgent);

export const isSafari = /^((?!chrome).)*safari/i.test(navigator.userAgent);

export const isWebpSupportedBrowser = !isInternetExplorer && !isSafari;
